import PropTypes from "prop-types"
import React from "react"
import Map from "components/shared/google_maps/map"
import Marker from "components/shared/google_maps/marker"
const { string, shape, boolean } = PropTypes

export default class extends React.Component {
  static displayName = "LocationMap"

  static propTypes = {
    location: shape({
      name: string.isRequired,
      latitude: string,
      longitude: string,
      formattedAddress: string,
      fullFormattedAddress: string
    }),
    showMap: boolean,
    disableDefaultUIControls: boolean
  }

  state = { showMap: this.props.showMap }

  handleShowMapClick = e => {
    e.preventDefault()
    this.setState({ showMap: true })
  }

  getExactLocation = () => {
    const { location } = this.props

    if (!location.latitude) {
      return null
    }

    return {
      lat: parseFloat(location.latitude),
      lng: parseFloat(location.longitude)
    }
  }

  render() {
    const { location, disableDefaultUIControls } = this.props
    const { showMap } = this.state

    if (!location) {
      return null
    }

    const mapStyle = {
      width: "100%",
      height: "240px"
    }
    const mapOptions = { mapTypeControl: false, streetViewControl: false }
    const exactLocation = this.getExactLocation()

    return (
      <div>
        <div className="mb-2">
          {!showMap && (
            <button
              className="minor-btn secondary-btn btn"
              onClick={this.handleShowMapClick}
              type="button"
            >
              Show Map
            </button>
          )}
        </div>
        {showMap && (
          <>
            {exactLocation ? (
              <Map
                center={exactLocation}
                style={mapStyle}
                key="exactMap"
                options={mapOptions}
                disableDefaultUIControls={disableDefaultUIControls}
              >
                <Marker position={exactLocation} />
              </Map>
            ) : (
              <img
                css={{ width: "100%", height: 240 }}
                src="/static/preview-full-map.png"
                alt="Map with no location selected"
              />
            )}
          </>
        )}
      </div>
    )
  }
}
